import React, { useEffect, useState } from "react";
import { Phone } from "lucide-react";

export default function StickyCall() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <a
      href="tel:02131544154"
      data-testid="sticky-call-btn"
      aria-label="Jetzt anrufen"
      className={`md:hidden fixed bottom-5 left-5 z-40 inline-flex items-center gap-2 gold-bg text-black font-bold px-4 py-3 text-xs tracking-[0.25em] uppercase shadow-[0_10px_40px_rgba(250,204,21,0.35)] transition-all duration-300 ${
        show ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3 pointer-events-none"
      }`}
    >
      <Phone size={16} /> Anrufen
    </a>
  );
}
